import styled from "@emotion/styled";

export const Flex = styled.div`
  display: flex;
`;
